export var dashify = function(input) {
    return input ? input.toLocaleLowerCase().split(" ").join("-") : "";
};
export var undashifyAndCapitalise = function(input) {
    return input ? input.replace(/-/g, " ").replace(/^./, input[0].toUpperCase()) : "";
};
